import api from "./Api";
import { BASE_URL } from "./Context/config";

export interface PostFeedback {
  Category: string;
  Subject: string;
  Details: string;
}

export interface FeedbackResponse {
  Id: number;
  UserId: number;
  Category: string;
  Subject: string;
  Details: string;
  SubmittedAt: string;
  UserEmail: string;
}

export const SubmitFeedback = async (feedback: PostFeedback) => {
  const data = {
    Category: feedback.Category,
    Subject: feedback.Subject,
    Details: feedback.Details,
  };

  try {
    const response = await api.post(`${BASE_URL}/Feedback/submit`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("SubmitFeedback Error:", error);

    if (error.response) {
      // Server responded with error status
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.message ||
        `Server error: ${error.response.status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      // Network error
      throw new Error("Network error: Unable to connect to server");
    } else {
      // Other error
      throw new Error(error.message || "Unknown error occurred");
    }
  }
};

export const GetAllFeedback = async () => {
  try {
    const response = await api.get(`${BASE_URL}/Feedback/all`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("GetAllFeedback Error:", error);

    if (error.response) {
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.message ||
        `Server error: ${error.response.status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      throw new Error("Network error: Unable to connect to server");
    } else {
      throw new Error(error.message || "Unknown error occurred");
    }
  }
};

export const ExportFeedback = async () => {
  try {
    const response = await api.post(`${BASE_URL}/Feedback/export`, {}, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("ExportFeedback Error:", error);

    if (error.response) {
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.message ||
        `Server error: ${error.response.status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      throw new Error("Network error: Unable to connect to server");
    } else {
      throw new Error(error.message || "Unknown error occurred");
    }
  }
};
